import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resolveBrand } from '@/config/brand';

// 英文翻译资源
import enUS from './locales/en-US.json';
// 中文翻译资源
import zhCN from './locales/zh-CN.json';

export const SUPPORTED_LANGUAGES = [
  { key: 'zh-CN', label: '中文' },
  { key: 'en-US', label: 'English' },
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]['key'];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'zh-CN';

/**
 * 统一的「当前语种」获取逻辑（UI 展示与请求头 Accept-Language 共用）：
 * 1. 用户手动选择过（localStorage 有值）→ 以用户选择为准
 * 2. 未手动选择过 → 使用品牌站点默认语种（如 juxflow.ame-film.com 默认 en-US）
 * 3. 兜底 → 全局默认 zh-CN
 * 保证请求头语种与 UI 实际展示语种一致，且随语言切换动态变化。
 */
export const getCurrentLanguage = (): SupportedLanguage => {
  const saved = localStorage.getItem('i18n_language');
  if (saved === 'zh-CN' || saved === 'en-US') return saved;
  return resolveBrand().defaultLanguage ?? DEFAULT_LANGUAGE;
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'zh-CN': { translation: zhCN },
      'en-US': { translation: enUS },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    lng: getCurrentLanguage(),
    interpolation: {
      escapeValue: false, // React already safes from XSS
    },
  });

export default i18n;
